export const useRouteStore = defineStore('route', () => {
  const history = ref<(string | symbol)[]>([])
  return { history }
})
